var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c(
    "div",
    { staticStyle: { height: "100%" } },
    [
      _c("vue-dropzone", {
        ref: "filedropzone",
        attrs: {
          id: "filedropzone" + _vm.id,
          options: _vm.dropzoneOptions,
          "additional-classes": _vm.additionalClasses,
        },
        on: {
          "vdropzone-file-added": (file) => _vm.acceptFile(file),
          "vdropzone-processing": (file) => _vm.processFile(file),
          "vdropzone-sending": (file, xhr) => _vm.sendingFile(file, xhr),
          "vdropzone-complete": (file) => _vm.successFile(file),
          "vdropzone-error": _vm.dropzoneError,
        },
      }),
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }